import { Pipe, PipeTransform } from '@angular/core';
import { APP_ROUTES } from '@cpd-app/core-module/constants/routes';
import * as marked from 'marked';

@Pipe({
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {
  public transform(value: string, isSkillSurveyCompleted = false): string {
    const parsedHtml = marked.parse(value) as string;

    return parsedHtml
      .replace(
        /<table[^>]*>[\s\S]*?<\/table>/gi,
        '<div class="table-wrapper">$&</div>'
      )
      .replace(/<a[^>]*>[\s\S]*?<\/a>/gi, (match) => {
        const href = match.match(/href="([^"]+)"/)?.[1];
        const text = match.match(/<a[^>]*>(.*?)<\/a>/)?.[1];

        const isTakeSurveyLink = [
          APP_ROUTES.CareerPlanning.SkillsSurvey,
          APP_ROUTES.CareerPlanning.InterestsSurvey,
          APP_ROUTES.CareerPlanning.ValuesSurvey,
          APP_ROUTES.CareerPlanning.LifestyleSurvey
        ].includes(href);
        const isSkillsSurvey = href === APP_ROUTES.CareerPlanning.SkillsSurvey;

        if (!isTakeSurveyLink) {
          return `<a href="${href}" class="link" target=_blank'}">${this.getTextbyLink(href, text)}</a>`;
        } else {
          if (isSkillsSurvey || isSkillSurveyCompleted) {
            return `<a href="${href}" class="link"}">${this.getTextbyLink(href, text)}</a>`;
          }

          return `<a class="link">${this.getTextbyLink(href, text)}: Take the Skill Survey first. </a>`;
        }
      });
  }

  private getTextbyLink(href: string, text: string): string {
    if (href === APP_ROUTES.CareerPlanning.Base) {
      return 'Home';
    }

    if (href === APP_ROUTES.CareerPlanning.BuildTarget) {
      return 'Build Your Target';
    }

    if (href === APP_ROUTES.CareerPlanning.SkillsSurvey) {
      return 'Skill Survey';
    }

    if (href === APP_ROUTES.CareerPlanning.InterestsSurvey) {
      return 'Interests Survey';
    }

    if (href === APP_ROUTES.CareerPlanning.ValuesSurvey) {
      return 'Work Values Survey';
    }

    if (href === APP_ROUTES.CareerPlanning.LifestyleSurvey) {
      return 'Lifestyle Survey';
    }

    return text;
  }
}
